import { createRoot } from 'react-dom/client';
import CaseInsensitivePropertyMapper from '../CaseInsensitivePropertyMapper';
import ThemeProviderCustom from '../../components/atoms/theme-provider-custom';

// todo: refactor this as a loader so we don't have to do any extra work at runtime
const create = ({ appId, Component, contextProperties, Redux = null }) => {
  const fullAppId = `${process.env.F2_APP_ID_PREFIX}${appId}`;
  // console.log('f2AppClassFactory', contextProperties);
  /**
   * @Styles=false
   */
  F2.Apps[fullAppId] = class F2Class {
    constructor(appConfig, appContent, root) {
      this.appConfig = appConfig || {};
      this.appContent = appContent;
      this.root = createRoot(root);
    }

    init() {
      let app = (
        <ThemeProviderCustom>
          <Component
            className={`${fullAppId} ${process.env.MD_ROOT_CLASS}`}
            {...CaseInsensitivePropertyMapper.map(contextProperties).from(
              this.appConfig.context
            )}
          />
        </ThemeProviderCustom>
      );

      // Optionally wrap `app` in a redux store, if provided
      if (Redux) {
        app = (
          <Redux.Provider store={Redux.store}>
            {app}
          </Redux.Provider>);
      }

      this.root.render(app);
    }

    destroy() {
      this.root.unmount();
    }
  };
};

const f2AppClassFactory = {
  create
};

export default f2AppClassFactory;
